<template>
  <div class="specification">
    <div class="spec-title">Specification</div>

    <div class="table-item">
      <div
        v-for="(item, idx) in previewSepcs"
        :key="idx"
        class="inner-item"
      >
        <div class="col col-name">{{ item.name }}</div>
        <div class="col col-value">{{ item.value }}</div>
      </div>
    </div>

    <div v-if="specification.length > 6" class="show-all" @click="handleShowAllClick">
      {{ showAll ? 'Show less' : 'Show more'}}
      <van-icon :name="showAll ? 'arrow-up' : 'arrow-down'" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface ISpecification { name: string, value: string[] }
const props = defineProps<{ specification: ISpecification[] }>()

const showAll = ref<boolean>(false)
const handleShowAllClick = () => {
  showAll.value = !showAll.value
}
const previewSepcs = computed(() => {
  const { specification } = props

  const list = [ ...specification ]

  // 如果是奇数，补一个空值
  if(list.length % 2 !== 0) {
    list.push({ name: '', value: [''] })
  }

  let showLen = 6
  if (showAll.value) {
    showLen = list.length
  }
  
  return list.map(c => ({ name: c.name, value: c.value.join(',') })).splice(0, showLen)
})
</script>

<style lang="scss" scoped>
.specification {
  width: 100%;
  padding: 0 20px;
  padding-bottom: 20px;
  background-color: #fff;
}
.spec-title{
  font-size: 38px;
  padding: 30px 0;
  font-weight: 600;
}
.show-all{
  text-align: center;
  color: var(--pc-default-color);
  font-size: 30px;
  padding: 20px 0;
  cursor: pointer;
}

.table-item {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #efefef;;
  border-bottom: none;
  .inner-item{
    border-bottom: 1px solid #efefef;
    width: 50%;
    display: flex;

    .col{
      flex: 1;
      text-align: center;
      line-height: 50px;
      text-align: left;
      padding: 20px 30px;
    }
    .col-name{
      flex: 0.5;
      background-color: #f5f5f5;
    }
    .col-value{
      flex: 1;
    }
  }
}
</style>